import { configureStore } from '@reduxjs/toolkit';
import { errorsInterceptor } from '../shared/middlewares/errorsInterceptor';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const noopStorage = {
  getItem: () => Promise.resolve(null),
  setItem: () => Promise.resolve(),
  removeItem: () => Promise.resolve(),
};

const safeStorage = (() => {
  try {
    localStorage.setItem('__test__', '1');
    localStorage.removeItem('__test__');
    return storage;
  } catch {
    return noopStorage;
  }
})();

// Reducers
import { userReducer, articlesReducer, partnersReducer } from './reducers/App/_index';
import { salesInterestsReducer, visitsReducer, offersReducer, buyerAlertsReducer } from './reducers/BuyerApp/_index';
import { sellerSalesReducer, sellerOffersReducer, sellerPhotoMeetingsReducer, sellerVisitsReducer, sellerUnavailabilitiesReducer, sellerDocumentsReducer, sellerEstimationFoldersReducer, sellerOnlineEstimationsReducer, sellerMandatesReducer, sellerSalesUsersReducer } from './reducers/SellerApp/_index';
import { estimationFunnelReducer, rentalFunnelReducer, radarReducer, buyerAlertCreatorReducer, sponsorshipModuleReducer } from './reducers/_Pages/_index';

// Redux persist config
const estimationFunnelPersistConfig = {
  key: 'estimationFunnel',
  storage: safeStorage,
  blacklist: ['allSteps', 'currentStep']
};

const persistedEstimationFunnelReducer = persistReducer(estimationFunnelPersistConfig, estimationFunnelReducer);

const rentalFunnelPersistConfig = {
  key: 'rentalFunnel',
  storage: safeStorage,
  blacklist: ['allSteps', 'currentStep']
};

const persistedRentalFunnelReducer = persistReducer(rentalFunnelPersistConfig, rentalFunnelReducer);

const reducers = {
  // Reducers only for General App
  user: userReducer,
  articles: articlesReducer,
  partners: partnersReducer,

  // Reducers only for BuyerApp
  buyerSalesInterests: salesInterestsReducer,
  buyerVisits: visitsReducer,
  buyerOffers: offersReducer,
  buyerBuyerAlerts: buyerAlertsReducer,

  // Reducers only for SellerApp
  sellerSales: sellerSalesReducer,
  sellerOffers: sellerOffersReducer,
  sellerPhotoMeetings: sellerPhotoMeetingsReducer,
  sellerVisits: sellerVisitsReducer,
  sellerUnavailabilities: sellerUnavailabilitiesReducer,
  sellerDocuments: sellerDocumentsReducer,
  sellerEstimationFolders: sellerEstimationFoldersReducer,
  sellerOnlineEstimations: sellerOnlineEstimationsReducer,
  sellerMandates: sellerMandatesReducer,
  sellerSalesUsers: sellerSalesUsersReducer,

  // Reducers only for Public Pages
  estimationFunnel: persistedEstimationFunnelReducer,
  rentalFunnel: persistedRentalFunnelReducer,
  radar: radarReducer,
  buyerAlertCreator: buyerAlertCreatorReducer,
  sponsorshipModule: sponsorshipModuleReducer,
};

// Middlewares
let middlewares = [errorsInterceptor];

// Adds redux logger only in developement mode
if (process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}

export function setupStore(preloadedState) {
  return configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      immutableCheck: process.env.NODE_ENV !== 'test',
      serializableCheck: false
    }).concat(middlewares),
    reducer: reducers,
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production'
  })
}
